export default {
  "首页": "Beranda",
  "订单": "Pesanan",
  "新闻": "Berita",
  "个人中心": "Pusat Pribadi",
  "模拟账户": "Akun Demo",
  "可用资产": "Aset Tersedia",
  "入金": "Deposit",
  "出金": "Penarikan",
  "账单详情": "Detail Tagihan",
  "重置模拟账户": "Reset Akun Demo",
  "钱包": "Dompet",
  "实名认证": "Verifikasi Identitas",
  "邀请好友": "Undang Teman",
  "修改密码": "Ubah Kata Sandi",
  "投诉邮箱": "Email Pengaduan",
  "其它": "Lainnya",
  "公告": "Pengumuman",
  "语言": "Bahasa",
  "是否退出登录": "Apakah Anda ingin keluar?",
  "复制": "Salin",
  "复制成功": "Berhasil Disalin",
  "发送验证码成功": "Kode Verifikasi Berhasil Dikirim",
  "请输入密码": "Silakan masukkan kata sandi",
  "请再次输入密码": "Silakan masukkan kata sandi lagi",
  "复制邀请链接": "Salin Tautan Undangan",
  "上传身份": "Unggah sisi depan/belakang paspor/KTP Anda",
  "正面": "Sisi Depan",
  "上传正面": "Unggah Sisi Depan Paspor/KTP",
  "反面": "Sisi Belakang",
  "上传反面": "Unggah Sisi Belakang Paspor/KTP",
  "完善信息": "Silakan lengkapi informasi pribadi Anda",
  "输入姓名": "Masukkan nama Anda",
  "身份证号": "Nomor Paspor/KTP",
  "输入身份证号": "Masukkan nomor paspor/KTP Anda",
  "收款货币": "Mata Uang Penerimaan",
  "银行名称": "Nama Bank",
  "收款人账户": "Rekening Penerima",
  "货币": "Mata Uang",
  "分店名称": "Nama Cabang",
  "绑定银行卡": "Tautkan Kartu Bank",
  "银行地址": "Alamat Bank",
  "账号名称（假名）": "Nama Akun (Alias)",
  "绑定数字货币地址": "Tautkan Alamat Kripto",
  "余额": "Saldo",
  "联系客服": "Hubungi Layanan Pelanggan",
  "行情": "Pasar",
  "其他": "Lainnya",
  "设置": "Pengaturan",
  "收款人": "Penerima",
  "添加": "Tambah",
  "确认": "Konfirmasi",
  "取消": "Batal",
  "钱包地址": "Alamat Dompet",
  "请输入": "Silakan masukkan",
  "退出登录": "Keluar",
  "充值数量": "Jumlah Deposit",
  "提交": "Kirim",
  "银行卡": "Kartu Bank",
  "选择网络": "Pilih Jaringan",
  "数字货币": "Kripto",
  "上传验证": "Unggah Verifikasi",
  "提币地址": "Alamat Penarikan",
  "数量(USD)": "Jumlah (USD)",
  "备注": "Catatan",
  "手续费": "Biaya",
  "预计到账数量": "Perkiraan Jumlah Diterima",
  "暂无数据": "Tidak Ada Data",
  "入金记录": "Catatan Deposit",
  "提币记录": "Catatan Penarikan",
  "验证码": "Kode Verifikasi",
  "邀请码": "Kode Undangan",
  "提示": "Pemberitahuan",
  "请输入验证码": "Masukkan kode verifikasi",
  "姓名": "Nama",
  "邮箱登录": "Login Email",
  "邮箱": "Email",
  "密码": "Kata Sandi",
  "新用户": "Pengguna Baru",
  "立即加入": "Bergabung Sekarang",
  "忘记密码": "Lupa Kata Sandi",
  "登录": "Masuk",
  "无需开户,立即创建模拟账号进行交易!": "Tidak perlu buka akun, buat akun demo sekarang untuk trading!",
  "电话": "Telepon",
  "再次输入密码": "Masukkan kata sandi lagi",
  "职业": "Pekerjaan",
  "年收入": "Pendapatan Tahunan",
  "注册": "Daftar",
  "邮箱注册": "Daftar Email",
  "发送": "Kirim",
  "重置密码": "Reset Kata Sandi",
  "是否重置": "Apakah ingin reset?",
  "已重置": "Telah Direset",
  "名称": "Nama",
  "注册成功": "Pendaftaran Berhasil",
  "加载中": "Memuat",
  "您还未登录，请先登录": "Anda belum masuk, silakan masuk terlebih dahulu",
  "退出成功": "Berhasil Keluar",
  "市价": "Harga Pasar",
  "挂单": "Limit Order",
  "倍数": "Kelipatan",
  "止盈": "Ambil Untung",
  "止损": "Stop Loss",
  "买入数量": "Jumlah Beli",
  "每手": "Per Lot",
  "预估手续费": "Perkiraan Biaya",
  "预估保证金": "Perkiraan Margin",
  "买入": "Beli",
  "卖出": "Jual",
  "您的订单已确认": "Pesanan Anda telah dikonfirmasi",
  "订单页面": "Halaman Pesanan",
  "盈亏": "Untung/Rugi",
  "当前保证金": "Margin Saat Ini",
  "订单详情": "Detail Pesanan",
  "保证金": "Margin",
  "平仓": "Tutup Posisi",
  "修改": "Ubah",
  "手数": "Jumlah Lot",
  "暂无数据": "Tidak Ada Data",
  "历史": "Riwayat",
  "价格": "Harga",
  "请输入价格": "Masukkan harga",
  "手": "Lot",
  "搜索结果": "Hasil Pencarian",
  "搜索产品": "Cari Produk",
  "持仓": "Posisi",
  "语言": "Bahasa",
  "审核中": "Dalam Peninjauan",
  "请上传证件照正/反面": "Unggah foto identitas sisi depan/belakang",
  "上传成功": "Berhasil Diunggah",
  "上传失败": "Gagal Diunggah",
  "提交成功": "Berhasil Dikirim",
  "删除": "Hapus",
  "删除成功": "Berhasil Dihapus",
  "提币": "Penarikan",
  "缺少参数或传值错误": "Parameter kurang atau nilai salah",
  "操作成功": "Berhasil",
  "充值金额": "Jumlah Deposit",
  "类型": "Jenis",
  "状态": "Status",
  "时间": "Waktu",
  "单位": "Unit",
  "最高价": "Harga Tertinggi",
  "最低价": "Harga Terendah",
  "开盘价": "Harga Pembukaan",
  "请注册或登录真实账号": "Daftar atau masuk ke akun nyata",
  "没有更多了": "Tidak ada lagi",
  "提现金额": "Jumlah Penarikan",
  "审核通过": "Disetujui",
  "审核不通过": "Tidak Disetujui",
  "重新提交": "Kirim Ulang",
  "止盈价": "Harga Ambil Untung",
  "止损价": "Harga Stop Loss",
  "总盈亏": "Total Untung/Rugi",
  "撤单": "Batalkan Pesanan",
  "请先进行实名认证": "Silakan lakukan verifikasi identitas terlebih dahulu",
  "产品列表": "Daftar Produk",
  "下单": "Pesan",
  "可用资金": "Dana Tersedia",
  "欢迎登录": "Selamat Datang",
  "可用": "Tersedia",
  "冻结": "Dibekukan",
  "财务记录": "Catatan Keuangan",
  "交易对": "Pasangan Trading",
  "开仓时间": "Waktu Pembukaan Posisi",
  "收益": "Keuntungan",
  "操作": "Aksi",
  "下单价": "Harga Pemesanan",
  "当前价": "Harga Saat Ini",
  "订单号": "Nomor Pesanan",
  "请选择": "Silakan pilih",
  "卖出(做空)止损价不能低于开仓价": "Harga Stop Loss untuk Jual (Short) Tidak Bisa Lebih Rendah dari Harga Pembukaan",
  "卖出(做多)止盈价不能高于开仓价": "Harga Take Profit untuk Jual (Long) Tidak Bisa Lebih Tinggi dari Harga Pembukaan",
  "买入(做多)止损价不能高于开仓价": "Harga Stop Loss untuk Beli (Long) Tidak Bisa Lebih Tinggi dari Harga Pembukaan",
  "买入(做多)止盈价不能低于开仓价": "Harga Take Profit untuk Beli (Long) Tidak Bisa Lebih Rendah dari Harga Pembukaan",
  "买入(做多)止盈价不能低于开仓价和现价": "Harga Take Profit untuk Beli (Long) Tidak Bisa Lebih Rendah dari Harga Pembukaan dan Harga Saat Ini",
  "买入(做多)止损价不能高于开仓价和现价": "Harga Stop Loss untuk Beli (Long) Tidak Bisa Lebih Tinggi dari Harga Pembukaan dan Harga Saat Ini",
  "卖出(做空)止损价不能低于开仓价和现价": "Harga Stop Loss untuk Jual (Short) Tidak Bisa Lebih Rendah dari Harga Pembukaan dan Harga Saat Ini",
  "卖出(做多)止盈价不能高于开仓价和现价": "Harga Take Profit untuk Jual (Long) Tidak Bisa Lebih Tinggi dari Harga Pembukaan dan Harga Saat Ini",

  "提现手续费": "Gaji pengurusan pengunduran",
  "提现退回": "Mengundur kembali",
  "系统加款": "Sistem menambah ons",
  "系统减款": "Pengurangan sistem",

  "交易周期": "Siklus transaksi",
  "秒": "Detik",
  "交易额": "Jumlah transaksi",
  "买涨": "Beli sambil berharap harga naik",
  "买跌": "Beli sambil berharap harga turun",
  "秒数": "Jumlah detik",
  "交易类型": "Jenis transaksi",
  "看涨": "Optimis terhadap kenaikan harga",
  "看跌": "Pessimis terhadap kenaikan harga / Mengharapkan penurunan harga",
  "剩余时间": "Waktu yang tersisa",
  "买入价": "Harga pembelian",
  "结算价": "Harga penagihan",
  "交易额": "Jumlah transaksi",
  "下单时间": "Waktu pemesanan",
  "结算时间": "Waktu penagihan",
  "该币种暂无交易": "Tidak ada transaksi untuk uang ini",

  "总资产": "Total Aset",
  "币种": "Mata Uang",
  "资产折合": "Konversi Aset",
  "冻结金额": "Jumlah Dibiarkan",
  "可用金额": "Jumlah yang Tersedia",
  "公司资产": "Aset Perusahaan",
  "请输入旧密码": "Masukkan kata sandi lama",
  "请输入新密码": "Masukkan kata sandi baru",
  "请再次输入新密码": "Masukkan lagi kata sandi baru",
  "白皮书": "Buku Putih",
  "注册证书": "Sertifikat Pendaftaran",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Hak interpretasi akhir dari informasi di atas milik pihak resmi.",
  "上一页": "Halaman Sebelumnya",
  "下一页": "Halaman Berikutnya",
  "关闭": "Tutup",
  "闪电兑换": "Austausch Cepat",
  "全部": "Semua",
  "可用余额": "Saldo yang Tersedia",
  "到": "Ke",
  "请输入数量": "Masukkan jumlah",
  "币种选择": "Pilihan Mata Uang",
  "从": "Dari",
  "兑换": "Tukar",
  "兑换成功！": "Tukar berhasil!",
  "支付": "Bayar",
  "全部兑换成功": "Semua tukar berhasil",
  "获取": "Dapatkan",
  "数量": "jumlah",
  "拒绝原因": "Menolak Alasan",
  "交易密码": "Kata sandi transaksi",
  "设置交易密码": "Atur kata sandi transaksi",
  "重置交易密码": "Atur ulang kata sandi transaksi",
  "确定": "Konfirmasi",
  "是否购买？": "Beli?",
  "外汇": "Valuta Asing",
  "期权": "Opsi",
  "(用户中心)": "(Pusat Pengguna)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Transaksi Anda sedang diproses, harap tunggu dengan sabar hingga transaksi selesai sebelum melakukan operasi lainnya!",
  "继续下单": "Lanjutkan pesanan",
  "交易方向": "Arah perdagangan",
  "实现盈利": "Mencapai keuntungan",
  "最新价格": "Harga terbaru",
  "结算完成": "Penyelesaian selesai",
  "下单余额不足": "Saldo tidak cukup untuk melakukan pemesanan",
  "输入交易额度": "Masukkan jumlah transaksi",
  "选择交易周期": "Pilih periode transaksi",
  "审核拒绝": "Tinjauan ditolak",
  "请输入正确的数量!": "Silakan masukkan jumlah yang benar!",
  "上传身份": "Unggah identitas",
  "上传正面": "Unggah sisi depan",
  "上传反面": "Unggah sisi belakang",
  "完善信息": "Lengkapi informasi",
  "输入姓名": "Masukkan nama",
  "输入身份证号": "Masukkan nomor identitas",
  "身份证号": "Nomor identitas",
  "请上传证件照正/反面": "Silakan unggah foto dokumen bagian depan/belakang",
  "最小提现金额10USDT": "Jumlah penarikan minimum adalah 10 USDT",
  "证件号码": "Nomor Identitas",
  "输入证件号码": "Masukkan Nomor Identitas",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Silakan unggah KTP, SIM, atau paspor Anda untuk verifikasi identitas!"


}
